import {
  Text,
  VStack,
  HStack,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  RadioGroup,
  Radio,
  Divider,
} from '@chakra-ui/react';

import Card from 'components/card/Card';
import { useAppSelector, useAppDispatch } from 'hooks';
import {
  setClientName,
  setClientCode,
  setClientEmail,
  setIsRemarket,
  setHasLoa,
  useLegacyAutoFormLocked,
} from 'reducers/legacyAutoFormReducer';

const PersonalSubmissionSection = () => {
  const dispatch = useAppDispatch();
  const isLocked = useLegacyAutoFormLocked();

  const clientName = useAppSelector(
    (state) => state.legacyAutoForm.data.client_information.client_name,
  );
  const clientCode = useAppSelector(
    (state) => state.legacyAutoForm.data.client_information.client_code,
  );
  const clientEmail = useAppSelector(
    (state) => state.legacyAutoForm.data.client_information.client_email,
  );
  const isRemarket = useAppSelector(
    (state) => state.legacyAutoForm.data.client_information.is_remarket,
  );
  const hasLoa = useAppSelector(
    (state) => state.legacyAutoForm.data.client_information.has_loa,
  );
  const validationErrors = useAppSelector(
    (state) => state.legacyAutoForm.validationErrors,
  );

  const handleClientNameChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    dispatch(setClientName(event.target.value));
  };

  const handleClientCodeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    dispatch(setClientCode(event.target.value));
  };

  const handleClientEmailChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    dispatch(setClientEmail(event.target.value));
  };

  const handleIsRemarketChange = (value: string) => {
    dispatch(setIsRemarket(value === 'yes'));
  };

  const handleHasLoaChange = (value: string) => {
    dispatch(setHasLoa(value === 'yes'));
  };

  return (
    <Card mb="20px" id="sectionPersonalSubmission">
      <Text fontWeight="bold" fontSize="2xl" mb="20px">
        Client Information
      </Text>

      <VStack spacing={4} align="stretch">
        <HStack spacing={4} align="stretch">
          <FormControl
            flex={1}
            isRequired
            isInvalid={!!validationErrors?.client_name}
          >
            <FormLabel ml="0">Client Name</FormLabel>
            <Input
              variant="main"
              value={clientName}
              onChange={handleClientNameChange}
              placeholder="Enter client name"
              borderColor={!clientName ? 'red' : 'inherit'}
              isDisabled={isLocked}
            />
            {validationErrors?.client_name && (
              <FormErrorMessage>
                {validationErrors.client_name}
              </FormErrorMessage>
            )}
          </FormControl>

          <FormControl
            flex={1}
            isRequired
            isInvalid={!!validationErrors?.client_code}
          >
            <FormLabel ml="0">Client Code</FormLabel>
            <Input
              variant="main"
              value={clientCode}
              onChange={handleClientCodeChange}
              placeholder="Enter client code"
              borderColor={!clientCode ? 'red' : 'inherit'}
              isDisabled={isLocked}
            />
            {validationErrors?.client_code && (
              <FormErrorMessage>
                {validationErrors.client_code}
              </FormErrorMessage>
            )}
          </FormControl>
        </HStack>

        <FormControl isInvalid={!!validationErrors?.client_email}>
          <FormLabel ml="0">Client Email Address</FormLabel>
          <Input
            variant="main"
            type="email"
            value={clientEmail}
            onChange={handleClientEmailChange}
            placeholder="Enter client email address"
            isDisabled={isLocked}
          />
          {validationErrors?.client_email && (
            <FormErrorMessage>{validationErrors.client_email}</FormErrorMessage>
          )}
        </FormControl>

        <Divider my={4} />

        <Text fontWeight="bold" fontSize="lg" mb={2}>
          Submission Context
        </Text>

        <HStack spacing={8} align="flex-start">
          <FormControl flex={1}>
            <FormLabel ml="0">Is This Submission a Remarket?</FormLabel>
            <RadioGroup
              value={isRemarket ? 'yes' : 'no'}
              onChange={handleIsRemarketChange}
              isDisabled={isLocked}
            >
              <HStack spacing={8}>
                <Radio value="yes">Yes</Radio>
                <Radio value="no">No</Radio>
              </HStack>
            </RadioGroup>
          </FormControl>

          <FormControl flex={1}>
            <FormLabel ml="0">LOA</FormLabel>
            <RadioGroup
              value={hasLoa ? 'yes' : 'no'}
              onChange={handleHasLoaChange}
              isDisabled={isLocked}
            >
              <HStack spacing={8}>
                <Radio value="yes">Yes</Radio>
                <Radio value="no">No</Radio>
              </HStack>
            </RadioGroup>
          </FormControl>
        </HStack>
      </VStack>
    </Card>
  );
};

export default PersonalSubmissionSection;
